import { render } from "./EditCategoryView.vue?vue&type=template&id=2d2e65ee"
import script from "./EditCategoryView.vue?vue&type=script&lang=js"
export * from "./EditCategoryView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__